import { render, staticRenderFns } from "./Mt940Form.vue?vue&type=template&id=34b4900e&"
import script from "./Mt940Form.vue?vue&type=script&lang=ts&"
export * from "./Mt940Form.vue?vue&type=script&lang=ts&"
import style0 from "./Mt940Form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports